var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSpeedometer = function SvgSpeedometer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.367 6.343c-.447-.061-.903-.093-1.367-.093-5.523 0-10 4.477-10 10 0 .552.448 1 1 1s1-.448 1-1c0-4.418 3.582-8 8-8l.453.013.914-1.92zm4.994 5.056c1.028 1.346 1.638 3.027 1.638 4.851 0 .552.448 1 1 1s1-.448 1-1c0-2.641-1.024-5.043-2.696-6.83l-.942 1.979zM17.67 5.078c.499.237.71.834.473 1.333l-5 10.5c-.237.499-.834.71-1.333.473s-.71-.834-.473-1.333l5-10.5c.238-.499.834-.71 1.333-.473z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeedometer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speedometer.b6b1393c.svg";
export { ForwardRef as ReactComponent };